import { Injector } from '@angular/core';
import { ProductConfigurationFacade } from '@features/client/order-workflow/facades/product-configuration.facade';
import { of } from 'rxjs';

export const dynamicForms = [
  {
    key: 'order_product_configuration_form',
    callback: (injector: Injector) => {
      const productConfigurationFacade = injector.get(ProductConfigurationFacade);
      const orderProduct = productConfigurationFacade.getOrderProductSnapshot();

      return orderProduct ? of(orderProduct.configuration) : of(null);
    },
  },
];
